import { createContext, useContext } from "react";
import { CompleteJson, Table } from "../types/DealTracker";

export interface DealsTableCardContextValue<TTable = any, TRow = any> {
  table: TTable;
  rowData: TRow[];

  isTableOpen: boolean;
  isExpanded: boolean;

  toggleTableOpen: () => void;
  toggleExpand: () => void;

  handleAddRow: () => void;
  hiddenColsCount: number;
  handleShowAllHidenCol: () => void;
  onBtnCsvExport: () => void;
}

export const DealsTableCardContext = createContext<DealsTableCardContextValue<
  Table,
  CompleteJson
> | null>(null);

export function useDealsTableCard() {
  const ctx = useContext(DealsTableCardContext);
  if (!ctx) {
    throw new Error(
      "TableCard components must be used inside <DealsTableCard />"
    );
  }
  return ctx;
}
